/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idUnidade: string | null;
  idLeadCorretor: number;
}

export function useResetarFluxo(props: Props) {
  const updateData = async () => {
    const RESETAR_FLUXO = `${backofficeEnviroment}/common/oportunidades-lead/resetar-fluxo-simulador/v1/${props.idUnidade}/${props.idLeadCorretor}`;
    return await instance.put(RESETAR_FLUXO);
  };
  const query = useMutation({
    mutationFn: async () => await updateData(),
    mutationKey: ["resetar-fluxo"],
    onSuccess: () => {
      toast.success("Fluxo resetado com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao resetar fluxo. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
